import { organisationDetailsFixture, type OrganisationDetails, type OrganisationDetailsState, type OrganisationFieldError, validateOrganisationDetails } from './organisationDetailsModel';

export type OrganisationScenario = 'default' | 'permissionDenied';

export interface SaveOrganisationResult {
  ok: boolean;
  errors?: OrganisationFieldError;
}

export const loadOrganisationDetails = async (scenario: OrganisationScenario = 'default'): Promise<OrganisationDetailsState> => {
  await Promise.resolve();

  if (scenario === 'permissionDenied')
    return {
      details: organisationDetailsFixture,
      permissions: {
        canEdit: false,
        canEditRestrictedStatus: false,
        canView: false,
      },
    };

  return {
    details: organisationDetailsFixture,
    permissions: {
      canEdit: true,
      canEditRestrictedStatus: false,
      canView: true,
    },
  };
};

export const saveOrganisationDetails = async (details: OrganisationDetails): Promise<SaveOrganisationResult> => {
  await Promise.resolve();
  const errors = validateOrganisationDetails(details);
  if (Object.keys(errors).length > 0) return { ok: false, errors };
  return { ok: true };
};
